<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

    <v-layout py-3>
   		<v-flex xs12>
   			<v-form v-model="validForm">
          <v-card>
            <v-card-title class="px-4">
              <v-flex xs12 sm4>
                <div class="subheading text-uppercase font-weight-light" v-if="saleReturn.code">
                  <span>ID: </span>
                  <span>{{saleReturn.code}}</span>
                </div>
                <div class="subheading font-weight-light" v-if="saleReturn.invoice">
                  <span>{{saleReturn.invoice.retailer.title}}</span>
                </div>
              </v-flex>
              <v-flex xs6 sm4 class="text-xs-center">
                <span class="headline text-uppercase font-weight-light pt-4">Sales Return</span>
              </v-flex>
              <v-flex xs6 sm4 class="text-xs-right">
                <div class="body-2 font-weight-light py-2">
                  <v-icon class="mr-1">date_range</v-icon>
                  <span>{{saleReturn.date}}</span>
                </div>
                <div class="body-1" v-if="saleReturn.biller_name">
                  <span>Biller: {{saleReturn.biller_name}}</span>
                </div>
              </v-flex>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md class="grey lighten-5">
                
                <v-layout wrap>

                  <v-flex xs12 sm3>
                    <div v-if="!saleReturn.invoice" class="py-2 px-3">
                      <v-autocomplete :loading="salesLoading" v-model="saleReturn.invoice_id" :search-input.sync="salesSearchText" :items="sales" item-text="code" item-value="id" label="Search Sales" hide-no-data>
                      </v-autocomplete>
                    </div>
                    <div v-else>
                      <div class="body-1">SALE ID: {{saleReturn.invoice.code}}</div>
                    </div>
                  </v-flex>

                  <v-flex xs12 sm6 v-if="isFranchiseeInvoice">
                    <div class="subheading text-uppercase font-weight-light">
                      <span>Branch/Franchisee</span>
                    </div>
                    <div class="py-2 px-3">
                      <div class="body-1">{{saleReturn.invoice.franchisee.title}}</div>
                      <div class="caption">{{saleReturn.invoice.franchisee.phone}}</div>
                    </div>
                  </v-flex>

                  <v-flex xs12 sm6 v-if="isCustomerInvoice">
                    <div class="subheading text-uppercase font-weight-light">
                      <span>Customer</span>
                    </div>
                    <div class="py-2 px-3">
                      <div class="body-1">{{saleReturn.invoice.customer.title}}</div>
                      <div class="caption">{{saleReturn.invoice.customer.mobile}}</div>
                      <div class="caption" v-if="saleReturn.invoice.customer.address1">{{saleReturn.invoice.customer.address1}}</div>
                      <div class="caption" v-if="saleReturn.invoice.customer.address2">{{saleReturn.invoice.customer.address2}}</div>
                    </div>
                  </v-flex>

                </v-layout>

              </v-container>

              <v-container>
                <v-layout wrap>
                  <v-flex xs12>
                    <div>
                      <div class="v-table__overflow">
                        <table class="v-datatable v-table">
                          <thead>
                            <tr>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Item Code</span>
                              </th>
                              <!-- <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Item Name</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Unit</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right">
                                <span>Rate ({{currency}})</span>
                              </th> -->
                              <th role="columnheader" scope="col" class="column" :class="viewMode || approveMode ? 'text-xs-right' : 'text-xs-left'">
                                <span>P QTY</span>
                              </th>
                              <th role="columnheader" scope="col" class="column" :class="viewMode || approveMode ? 'text-xs-right' : 'text-xs-left'">
                                <span>Dmg QTY</span>
                              </th>
                              <th role="columnheader" scope="col" class="column" :class="viewMode || approveMode ? 'text-xs-right' : 'text-xs-left'">
                                <span>Non Dmg</span>
                              </th>
                              <th role="columnheader" scope="col" class="column" :class="viewMode || approveMode ? 'text-xs-right' : 'text-xs-left'">
                                <span>Total Ret</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right">
                                <span>Amount ({{currency}})</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="!viewMode && !approveMode">
                                <span>Actions</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="saleReturn.invoice && saleReturn.items && saleReturn.items.length > 0">
                            <tr is="sales-return-item" v-for="(item, index) in saleReturn.items" :item="item" :invoiceItems="saleReturn.invoice.items" :index="index" v-on:delete="deleteItem" :viewMode="viewMode" :approveMode="approveMode"></tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td colspan="8">No Items Added</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6 md8>
                    <v-layout class="align-start justify-end column fill-height pr-3">
                      <div class="body-2" v-if="amountInWords">
                        <span class="grey--text text--darken-2">Total Return Amount (In Words): </span>
                        <span class="font-weight-light">{{amountInWords}}</span>
                      </div>
                      <div class="body-2" v-if="(extra_discount > 0) || (viewMode && saleReturn.extra_discount > 0)">
                        <span class="grey--text text--darken-2">Extra Discount Narration: </span>
                        <span class="font-weight-light">{{extraDiscountNarration}}</span></div>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-right justify-end py-3 pl-3 pr-3">
                    <table class="total-table">
                      <tbody>
                        <tr class="body-2">
                          <td width="66%">Subtotal ({{currency}}): </td>
                          <td width="34%">{{ viewMode ? saleReturn.subtotal : subtotal | roundValue }}</td>
                        </tr>
                        <tr class="body-1" v-if="!viewMode">
                          <td>
                            Discount (<span>{{ discount_percent }}</span>%): 
                          </td>
                          <td>
                            <span v-if="discount > 0">-</span>{{ discount | roundValue }}
                          </td>
                        </tr>
                        <tr class="body-1" v-else-if="saleReturn.invoice && saleReturn.invoice.discount_percent > 0">
                          <td>Discount (<span>{{ saleReturn.invoice.discount_percent }}</span>%):</td>
                          <td><span>-</span>{{ saleReturn.discount | roundValue }}</td>
                        </tr>
                        <tr class="body-1" v-if="!viewMode">
                          <td>
                            Extra Discount (<span>{{ extra_discount_percent }}</span>%): 
                          </td>
                          <td>
                            <span v-if="extra_discount > 0">-</span>{{ extra_discount | roundValue }}
                          </td>
                        </tr>
                        <tr class="body-1" v-else-if="saleReturn.invoice && saleReturn.invoice.extra_discount_percent > 0">
                          <td>Extra Discount (<span>{{ saleReturn.invoice.extra_discount_percent }}</span>%):</td>
                          <td><span>-</span>{{ saleReturn.extra_discount | roundValue }}</td>
                        </tr>
                        <tr class="body-1">
                          <td>Roundoff ({{currency}}): </td>
                          <td v-if="viewMode">{{ saleReturn.round_off | roundValue }}</td>
                          <td v-else>
                            <v-edit-dialog color="white" :return-value.sync="round_off" lazy @open="openRoundOff" @close="closeRoundOff" class="text-xs-right justify-end"> {{ saleReturn.round_off | roundValue }}
                              <v-text-field type="number" :rules="roundOffRules" slot="input" v-model="round_off" label="Enter Amount" single-line></v-text-field>
                            </v-edit-dialog>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <v-divider class="my-2"></v-divider>
                    <table class="total-table">
                      <tbody>
                        <tr class="body-1 font-weight-medium" v-if="tax > 0">
                          <td width="66%">Total Amount ({{currency}}): </td>
                          <td width="34%">{{ viewMode ? saleReturn.total : total | roundValue }}</td>
                        </tr>
                        <tr class="body-1 font-weight-medium" v-if="tax > 0">
                          <td width="66%">GST ({{ saleReturn.invoice.tax_percent }}%): </td>
                          <td width="34%">{{ viewMode ? saleReturn.tax : tax | roundValue }}</td>
                        </tr>
                        <tr class="subheading font-weight-medium">
                          <td width="66%">Return Grand Total ({{currency}}): </td>
                          <td width="34%">{{ viewMode ? saleReturn.grandtotal : grandtotal | roundValue }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                </v-layout>
              </v-container>

            </v-card-text>

            <v-card-actions v-if="!viewMode">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat :disabled="processing" to="/sales-return-list">Cancel</v-btn>
              <v-btn v-if="approveMode" color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="openConfirmDialog">Approve</v-btn>
              <v-btn v-else color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="upsertSaleReturn" v-text="saleReturn.id ? 'Update' : 'Save'"></v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

		    <action-dialog action="approve" :status="confirmDialog" @close="closeConfirmDialog" @success="upsertSaleReturn" />

   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  import cloneDeep from 'lodash/cloneDeep'
  import get from 'lodash/get'
  import SalesReturnItem from './SalesReturnItem'

  export default {
    name: 'SalesReturn',
    props: {
      viewMode: {
        default: false
      },
      approveMode: {
        default: false
      }
    },
    data () {
      return {
      	title: "Sales Return",
        validForm: false,
      	processing: false,
        salesLoading: false,
        salesSearchText: "",
        sales: [],
        confirmDialog: false,
        round_off: 0,
        saleReturn: {},
        defaultReturn: {
          id: "",
          date: this.today('Do MMM, YYYY'),
          items: [],
          round_off: 0,
          tax: 0,
          invoice_id: null,
          invoice: null
        },
        requireRule: [
          v => !!v || 'Field is required'
        ],
        codeRules: [
            v => !!v || 'Item code is required',
            v => v && v.length >= 4 || 'Must be more than 3 characters',
            v => v && v.length <= 20 || 'Maximum 20 characters allowed'
        ],
        rateRules: [
            v => !!v || 'Rate is required',
            v => /^([0-9]{2,7})$/.test(v) || 'Rate must be valid'
        ],
        roundOffRules: [
          v => !!v || 'Amount is required',
          v => /^-?\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/.test(v) || 'Amount must be valid'
        ]

      }
    },
    created () {

      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Sales Return',
            disabled: false,
            href: '/sales-return-list'
	        },
	        {
	          text: this.pageType,
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Sales Return')
    },
    methods: {

      calculateItemTotal (item) {
        return item.quantity * ( item.rate + ( ( item.rate * item.tax_percent ) / 100) )
      },

      upsertSaleReturn () {

        if (this.saleReturn.items.length === 0) return this.notifyError('emptySalesReturnItems')

        let zero_qty_items = this.saleReturn.items.filter(item => item.quantity === 0)

        if (zero_qty_items.length) {
          return this.notifyError('salesReturnItemsCountZero')
        }

        this.processing = true

        let data = this.extend(this.saleReturn, {
          retailer: this.saleReturn.invoice.retailer.id,
          discount: this.discount,
          extra_discount: this.extra_discount,
          total: this.total,
          subtotal: this.subtotal,
          tax: this.tax,
          grandtotal: this.grandtotal
        })

        let method = data.id ? 'put' : 'post'
        let api_path = data.id ? ( this.approveMode ? this.config.apis.approveSalesReturn.replace(":id", data.id) : this.config.apis.updateSalesReturn.replace(":id", data.id) ) : this.config.apis.saveSalesReturn

        this.axios[method](api_path, data)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              let successStatus = data.id ? 'updateSalesReturnSuccess' : 'insertSalesReturnSuccess'

              this.notifySuccess(successStatus)
              this.$router.push("/sales-return-list")
            }
            else{

              let errorStatus = data.id ? 'updateError' : 'insertError'

              this.notifyError(errorStatus)
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      deleteItem (index) {
        this.saleReturn.items.splice(index, 1)
      },

      initNewSaleReturn () {
        this.saleReturn = this.extend({}, this.defaultReturn)
      },

      loadSaleReturn (id) {
        this.processing = true
        
        let api_path = this.config.apis.getSalesReturn.replace(":id", id)

            api_path = this.approveMode ? `${api_path}?approveMode=true` : api_path

        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.saleReturn = response.data.data
            }
            else{
              this.saleReturn = this.initNewSaleReturn()
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      openRoundOff () {
        this.round_off = parseFloat(this.saleReturn.round_off)
      },

      closeRoundOff () {
        this.saleReturn.round_off = parseFloat(this.round_off ? this.round_off : this.saleReturn.round_off)
      },

      openConfirmDialog () {
        this.confirmDialog = true
      },

      closeConfirmDialog () {
        this.confirmDialog = false
      },

      loadInvoice () {
        
        this.processing = true
        
        let api_path = this.config.apis.getInvoice.replace(":code", this.saleReturn.invoice_id)

        api_path = `${api_path}?status=${this.config.saleStatus.delivered}`

        this.axios.get(api_path)
          .then((response) => {
            
            this.processing = false
            
            if (this.isSuccessResponse(response) && get(response, 'data.data.items')) {
              
              let invoice = response.data.data
              
              if (!this.saleReturn.id) {
                
                let return_items = invoice.items.map(item => {
                    item['damage_quantity'] = 0
                    item['non_damage_quantity'] = item['quantity']
                    return item
                  })
                this.saleReturn.items = cloneDeep(return_items)
              }
              this.saleReturn.invoice = invoice
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      searchInvoices () {

        let api_path = this.config.apis.getInvoices.replace(":page", 1).replace(":perPage", 5)

        api_path = `${api_path}?status=${this.config.saleStatus.delivered}&code=${this.salesSearchText}&code_like=true`
        
        this.processing = true
        this.axios.get(api_path)
          .then(response => {
            this.processing = false
            this.sales = this.isSuccessResponse(response) ? response.data.data.items : []
          })
          .catch((error) => {
            this.processing = false
          })
      }

    },
    mounted () {
      if (this.$route.params.saleReturnId) {
        this.loadSaleReturn(this.$route.params.saleReturnId)
      }
      else{
        this.initNewSaleReturn()
      }
    },

    computed: {

      hasInvoice() {
        return !!this.saleReturn.invoice
      },

      subtotal () {
        
        let total = 0
        
        if (this.saleReturn.items) {
          this.saleReturn.items.forEach( item => {
            total += item.total
          })
        }
        
        return total
      },

      total () {
        return ( this.subtotal + this.saleReturn.round_off ) - ( this.discount + this.extra_discount )
      },

      tax () {
        return this.total * this.invoiceTaxPercent / 100
      },

      invoiceTaxPercent () {
        return this.hasInvoice ? this.saleReturn.invoice.tax_percent : 0
      },

      grandtotal () {
        return this.tax + this.total
      },

      discount () {
        return ( this.subtotal * this.discount_percent ) / 100
      },

      extra_discount () {
        return ( (this.subtotal - this.discount) * this.extra_discount_percent ) / 100
      },

      pageType () {
        
        let title = "Add"
        
        if (this.viewMode) {
          title = "View"
        }
        else if(this.approveMode) {
          title = "Approve"
        }
        else if(this.$route.params.saleReturnId) {
          title = "Edit"
        }

        return title

      },

      amountInWords () {
        return this.amountToWords(this.grandtotal)
      },

      discount_percent () {
        return this.hasInvoice ? this.saleReturn.invoice.discount_percent : 0
      },

      extra_discount_percent () {
        return this.hasInvoice ? this.saleReturn.invoice.extra_discount_percent : 0
      },

      tax_percent () {
        return this.hasInvoice ? this.saleReturn.invoice.tax_percent : 0
      },

      isFranchiseeInvoice () {
        return this.hasInvoice && this.saleReturn.invoice.type == this.config.invoiceTypes.franchisee
      },

      isCustomerInvoice () {
        return this.hasInvoice && this.saleReturn.invoice.type == this.config.invoiceTypes.customer
      }

    },

    watch: {

      '$route' (to, from) {
        // react to route changes...
        if (to !== from && to.params.saleReturnId) {
          this.loadSaleReturn(to.params.saleReturnId)
        }
        else{
          this.saleReturn = this.initNewSaleReturn()
        }

      },

      salesSearchText (val) {
        if (val) {
          this.searchInvoices()
        }
      },

      'saleReturn.round_off' (val, oldVal) {
        if (!val) {
          this.saleReturn.round_off = 0
        }
      },

      'saleReturn.invoice_id' (val, oldVal) {
        if (val) {
          this.loadInvoice()
        }
      }

    },
    
    components: {
      'sales-return-item': SalesReturnItem
    }

  }
</script>
